module.exports = __webpack_public_path__ + "img/text.58fdd819.svg";